import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useReactivateFeideWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id) => authAPI.reactivateFeideWhitelist(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["feideWhitelists"]);
        queryClient.invalidateQueries(["feideWhitelist"]);
      },
    }
  );
};
